import itLocale from "element-ui/lib/locale/lang/it";
const it = {
  //意大利 Italian
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Vicina",
    },
    ReportError: {
      next: "successivo",
      h1: "Segnala errori consente agli utenti di comunicare con noi per risolvere eventuali problemi relativi ai dati e migliorare la qualità dei dati.",
      li1: "Se riscontri problemi con i dati o hai una domanda su questi dati",
      li2: "Se vuoi contribuire con informazioni aziendali per migliorare questi dati",
      li3: "Se scegli di non divulgare informazioni sulla tua azienda che potresti considerare private",
      li4: "Se hai suggerimenti costruttivi da darci per migliorare i servizi",
      h2: "Tutti i commenti inviati sono soggetti a verifica dei dati. Gli utenti devono completare il proprio profilo utente poiché il nostro rappresentante potrebbe contattarti per l'autenticazione e la verifica dei diritti della tua azienda per rappresentare la tua azienda.",
      Iamanemployeeofthissubjectcompany: "Sono un dipendente di questa azienda",
      Reportmycompany: "Segnala la mia azienda",
      Updatedata: "Aggiorna i dati",
      Reportinformationerrors: "Segnalare gli errori nelle informazioni",
      Reportotherscompany: "Segnalazione di altre aziende",
      Financial: "Finanziaria",
      Pleaseprovidemoreinfo: "Si prega di fornire maggiori informazioni",
      Year: "Anno",
      Business: "Attività commerciale",
      Noofemployees: "Numero di dipendenti",
      Coremanagement: "Gestione centrale",
      Corebusinessactivites: "Attività aziendali principali",
      IntBusiness: "Int' Business",
      Pleasedescribeyouractivites: "Descrivi le tue attività",
      Pleaselistcountriesyoudobusine:
        "Si prega di elencare i paesi in cui operate.",
      Corecompetency: "Competenza chiave",
      Businessoutlook: "prospettive commerciali",
      Uploadfiles: "Carica i file",
      Upload: "Caricamento",
      Cancel: "Cancellare",
      Submit: "Invia",
      Select: "Seleziona",
      Selectthedatacategoryyoureport:
        "Seleziona la categoria di dati che desideri segnalare",
      TotalCurrentAssets: "Attività correnti totali",
      CashBank: "Contanti e banca",
      Accountreceivable: "conto crediti",
      AdvancestoSuppliers: "Anticipi ai fornitori",
      Inventory: "Inventario",
      Tobeappointedexpense: "Da nominare spesa",
      Totalnoncurrentassets: "Attività non correnti totali",
      Longterminvestment: "Investimento a lungo termine",
      Fixedassetsnetvalue: "valore netto delle immobilizzazioni",
      Projectsunderconstruction: "Progetti in costruzione",
      Longtermtobeappointedexpenise: "A lungo termine da nominare spese",
      Deferredtaxdebit: "addebito per imposte differite",
      Totalcurrentliabilities: "Passività correnti totali",
      Accountpayable: "Conto pagamenti",
      Advancesfromclients: "Anticipi da clienti",
      Salariespayable: "Stipendi da pagare",
      Taxespayable: "Imposte da pagare",
      Otheraccountspayable: "Altri conti da pagare",
      Totalequity: "Patrimonio netto totale",
      Paidupcapital: "Capitale versato",
      Capitalreserves: "Riserve di capitale",
      Surplusreserves: "Riserve eccedenti",
      Undistrbutedporfit: "Utili non distribuiti",
      Totalassets: "Totale attivo",
      Turnover: "Fatturato",
      Costofgoodssold: "Costo dei beni venduti",
      Salestax: "Imposta sulle vendite",
      Grossprofit: "Utile lordo",
      Otheroperatingprofils: "Altri profili operativi",
      Salesexpense: "Spese di vendita",
      Managementexpense: "Spese di gestione",
      Financeexpense: "Spese finanziarie",
      Operatingprofit: "utile operativo",
      Nonoperatingincome: "Reddito non operativo",
      Profitbeforetax: "Utile prima delle imposte",
      Incometax: "Imposta sul reddito",
      Netincome: "Reddito netto",
      DataProblems: "Problemi relativi ai dati",
      CorrectInformation: "Informazioni corrette",
    },
  },
  Home: {
    Applications: "Applicazioni",
    SearchCompanies: "Cerca aziende",
    SearchLeads: "Cerca lead",
    SearchTrade: "Cerca commercio",
    SearchSanctions: "Cerca sanzioni",
    SearchNews: "Cerca notizie",
    RiskScan: "Scansione del rischio",
    SearchRelationship: "Ricerca relazione",
    DataServices: "Servizi dati",
    SearchCountries: "Cerca paesi",
    selectCountry: "Seleziona Paese",
    Entercompanyname: "Inserisci il nome dell'azienda",
    keWord: "Parola chiave",
    firstWord: "Esatta sinistra",
    search: "Cerca",
    homeSeachTitle: "Mettiamo a fuoco il business globale",
    homeTitleDetail:
      "CSI, una società di ricerca e IT basata sui dati, è specializzata in credito, rischio e big data. Offre strumenti digitali a investitori e professionisti aziendali globali, sfruttando analisi e algoritmi avanzati per fornire informazioni rapide e visive che facilitano un processo decisionale più intelligente.",
    phoneTitleDetail:
      "Per cercare, visualizzare e ottenere rapidamente informazioni aziendali, puoi anche utilizzare l'app CSI sul tuo telefono.",
    searchCompanyNum:
      "Cerca oltre 500 milioni di aziende in oltre 200 paesi e territori",
    newsHeadTitle:
      "Scopri le intuizioni strategiche che si celano dietro ogni titolo aziendale",
    sanctionHeadTitle:
      "Gestisci il commercio internazionale con sicurezza, verificando la conformità di aziende e prodotti alle sanzioni globali",
    tradeHeadTitle:
      "Trasformare i dati del commercio globale in informazioni strategiche di mercato",
    relationshipTitle:
      "Proprietà e controllo definitivi / Impronta degli investimenti / Rete della catena di fornitura / Semplificazione della conformità / Mitigazione dei rischi / Copertura globale",
    IndustryAnalysis: "Analisi del settore",
    BusinessAnalytics: "Analisi aziendale",
    ImportExportData: "Dati di import-export",
    CompanyNews: "Notizie aziendali",
    Sanctions: "Sanzioni",
    BusinessIntelligence: "Intelligenza aziendale",
    CompanyIdentityVerification: "Verifica dell'identità aziendale",
    KYCSolutions: "Soluzioni KYC",
    OwnershipPenetration: "Penetrazione della proprietà",
    CompanyFinancialAnalysis: "Analisi finanziaria aziendale",
    CreditRatings: "Rating del credito",
    CreditReports: "Rapporti di credito",
    ESGRatings: "Rating ESG",
    VendorScreening: "Selezione dei fornitori",
    MarketResearch: "Ricerche di mercato",
    EnterKeyword: "Inserisci la parola chiave",
    Country: "Paese",
    Company: "Azienda",
    Person: "Persona",
    Product: "Prodotto",
    EnterPersonName: "Inserisci il nome della persona",
    EnterCountryName: "Inserisci il nome del Paese",
    EnterproductName: "Inserisci le parole chiave del prodotto",
    EnterproductNamekeywordsorHSCode:
      "Inserisci le parole chiave del prodotto o il codice HS",
    Searchby: "Cerca per",
    SICStandardIndustryCode: "SIC - Codice standard di settore",
    HSCodeHarmonizedSystemCode: "Codice HS - Codice del Sistema Armonizzato",
    AIAssistance: "Assistenza tramite IA",
    EnterISICNACENAICSCSICAAAICGICS:
      "Inserisci ISIC / NACE / NAICS / CSIC / AAAIC / GICS",
    EnterHarmonizedSystemCode: "Inserire il codice del Sistema Armonizzato",
    SIC: "SIC",
    HSCode: "HSCode",
  },
  Toolbar: {
    Filter: "Filtra",
    Select: "Seleziona",
    Edit: "Modifica",
    Sortby: "Ordina per",
    Collect: "Raccogli",
    Saved: "Salvati",
    Compare: "Confronta",
    Export: "Esporta",
    Download: "Scarica",
    Update: "Aggiorna",
    Reporterror: "Segnala errore",
    Share: "Condividi",
    ascending: "ascendente",
    descending: "discendente",
    Yourfolder: "La tua cartella",
    RiskScanning: "Analisi dei rischi",
    CreditAssessment: "Valutazione del merito creditizio",
    DataAnalysis: "Analisi dei dati",
    NewPortfolio: "Nuovo portfolio",
    Print: "Stampa",
    Optimize: "Ottimizzare",
    ALL: "Tutti",
    Confirm: "Confermare",
  },
  Export: {
    Choosethedatafields: "Seleziona i campi dati che desideri esportare.",
    Enterkeywords: "Inserisci la parola chiave",
    Financialdata: "Dati finanziari",
    Reset: "Reset",
    Back: "Indietro",
    Howmanyresults:
      "Quanti risultati desideri esportare da questa ricerca? Puoi anche affinare la ricerca aggiungendo ulteriori filtri.",
    FileName: "Nome del file",
    Pleaseenterafilename: "Inserisci un nome file",
    SelectedList: "Elenco selezionato",
  },
  AiZaba: {
    whatareyousearchingfor: "cosa stai cercando?",
    CreditAnalyst: "Analista del credito",
    Assesses:
      "Valuta l’affidabilità creditizia di un’azienda, identifica i rischi finanziari, garantendo transazioni sicure attraverso l’analisi dei dati e i rating del credito.",
    LegalAdvisor: "Consulente legale",
    Provides:
      "Fornisce indicazioni sulla conformità, esamina i contratti e valuta rischi legali per garantire che le operazioni aziendali siano in linea con le leggi ed evitare controversie.",
    BizConsultant: "Consulente aziendale",
    Optimizes:
      "Ottimizza le catene di fornitura, identifica gli acquirenti e aumenta le vendite analizzando le tendenze del mercato e offrendo strategie su misura per migliorare l'efficienza.",
    EconomicAnalyst: "Analista economico",
    Analyzes:
      "Analizza l'industria e le tendenze economiche regionali, aiutando le aziende prendono decisioni informate e rimangono competitive.",
    HiImZabaYourresearchassistant:
      "Ciao, sono Zaba, la tua assistente di ricerca",
  },
  navigationBar: {
    Notifications: "Notifiche", //通知
    MarkasRead: "Segna come letto", //标记已读
    Viewall: "Visualizza tutto", //查看全部
    SilverSubscriber: "Abbonato Silver", //银级用户
    GoldSubscriber: "Abbonato Gold", //金级用户
    SubscriptionExpires: "L'abbonamento scade",
    AvailableCredits: "Crediti disponibili", //可用积分
    AddCredits: "Aggiungi crediti", //购买积分
    IndivdualAccount: "Account individuale", //个人账号
    GroupAccount: "Account di gruppo", //集团账
    UserAccount: "Account utente",
    Roles: "Ruoli", //角色
  },
  ListofResults: {
    Country: "Paese",
    Industry: "Settore",
    CompanyType: "Tipo di azienda",
    CompanySize: "Dimensioni dell'azienda",
    CompanyStatus: "Stato dell'azienda",
    CompanyName: "Nome dell'azienda",
    RegStatus: "Stato di registrazione",
    StateProvince: "Stato/Provincia",
    CityCounty: "Città/Contea",
    DistrictCity: "Distretto/Città",
    IncDate: "Data di costituzione",
    LegalForm: "Forma giuridica",
    CoID: "ID azienda",
    TaxNo: "Partita IVA",
    ListingInfo: "Informazioni sulla quotazione",
    Phone: "Telefono",
    Website: "Sito web",
    Email: "Email",
    LegalPerson: "Persona giuridica",
    PostCode: "Codice postale",
    ISIC: "ISIC",
    IndustryDescription: "Descrizione del settore",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Rating di credito",
    SolvencyIndex: "Indice di solvibilità",
    ProbabilityofDefault: "Probabilità di default",
    NoofEmployees: "Numero di dipendenti",
    Revenue: "Fatturato",
    TotalAsset: "Totale attivo",
    NetProfit: "Utile netto",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Mostra altro",
    SelectCountry: "Seleziona Paese",
    ClearAll: "Cancella tutto",
    SelectIndustry: "Seleziona Industria",
    ListedCompany: "Società quotata",
    YearsinBusiness: "Anni di attività",
    Sharethisinformation: "Condividi queste informazioni",
    Pleaseaddress: "Inserisci uno o più indirizzi email",
    Example: "Esempio",
    message: "messaggio",
    pleaseleaveamessage: "per favore lascia un messaggio",
    Include: "Includi",
    thisaddress: "il nome, l'ID e l'indirizzo della società",
    CSIwebsite: "Sito web del CSI",
    Update: "Aggiorna",
    Iftheavailable:
      'Se i dati disponibili online sono insufficienti o obsoleti, è possibile fare clic sul pulsante "Aggiorna" per richiedere un aggiornamento istantaneo per un rapporto di credito aziendale appena esaminato dai nostri investigatori di rete locali o agenzie di segnalazione del credito. Il costo per questo aggiornamento è di 1 credito per azienda. La consegna del report di aggiornamento richiede in genere dalle 24 alle 72 ore.',
    Abusinesscredit:
      "Un rapporto sul credito aziendale fornisce informazioni dettagliate sui dati identificativi della società in questione, sui registri, sulla struttura azionaria, sulla storia aziendale, sulla descrizione della gestione, sulle società collegate, sulle operazioni effettive, sui riferimenti commerciali, sui dati e sulle analisi finanziarie, sulle informazioni pubbliche ufficiali come i registri dei contenziosi e sulle sanzioni, nonché sull'analisi e sulla valutazione del credito.",
    Searchcompanies: "Cerca più email su altre società",
    Rowsperpage: "Righe per pagina",
    Remove: "Rimuovi",
    Confirm: "Conferma",
  },
  ContentTabs: {
    Background: "Contesto",
    BusinessActivities: "Attività aziendali",
    Performance: "Performance",
    Publications: "Pubblicazioni",
    CreditOpinion: "Opinione creditizia",
    MarketAnalysis: "Analisi di mercato",
    Snapshot: "Sintesi",
    Profile: "Profilo",
    Ownership: "Proprietà",
    RelatedCompanies: "Società collegate",
    Management: "Direzione",
    Operations: "Operazioni",
    Locations: "Sedi",
    Industry: "Settore",
    ImportExport: "Import ed export",
    SupplyChain: "Catena di fornitura",
    FinancialHighlights: "Dati finanziari salienti",
    RatioAnalysis: "Analisi degli indici",
    IndustryNorm: "Norme di settore",
    News: "Notizie",
    Sanctions: "Sanzioni",
    IndustryStatistics: "Statistiche di settore",
    RatingAnalysis: "Analisi del rating",
    CompetitiveAnalysis: "Analisi competitiva",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "Il Data Quality Index (DQI) utilizza algoritmi per valutare diversi aspetti dei dati, tra cui completezza, validità, affidabilità delle fonti, coerenza, tempestività e supporto bilingue.",
    CompanyDQIdesc2:
      "L'indice è progettato per valutare la qualità dei dati su una scala da 1 a 100, dove i punteggi più alti indicano una qualità dei dati superiore. Gli algoritmi possono analizzare i dati in base a regole o criteri predefiniti, consentendo misurazioni oggettive e standardizzate.",
    CompanyDQIdesc3:
      "Il nostro Data Quality Index (DQI) funge da indicatore affidabile, consentendo agli utenti di valutare quantitativamente la qualità dei dati. Ciò consente un processo decisionale basato sui dati e migliora il valore complessivo e l’utilità dei dati.",
    CountryDQIdesc1:
      "L'indice di qualità dei dati (DQI) valuta l'affidabilità, l'accuratezza e l'accessibilità dei dati tra i paesi, riflettendo le differenze nell'infrastruttura digitale, nella governance e nella trasparenza. Le nazioni sviluppate in genere si posizionano più in alto grazie a sistemi di dati forti, politiche aperte e tecnologia avanzata, mentre le economie in via di sviluppo spesso lottano con lacune nelle infrastrutture, nella regolamentazione o nelle pratiche di condivisione dei dati.",
    CountryDQIdesc2:
      "I fattori chiave includono la trasparenza del governo, le leggi sulla protezione dei dati e l’adozione della tecnologia. Un DQI elevato consente un migliore processo decisionale politico e aziendale, mentre un punteggio basso evidenzia le aree che necessitano di investimenti.",
    CompanyDQI: "DQI aziendale", //公司数据质量指数 DQI
    CountryDQI: "DQI nazionale", //国家数据质量指数 DQI
    CompanyTitle: "Indice di qualità dei dati (DQI) per azienda",
    CountryTitle: "Indice di qualità dei dati (DQI) per Paese",
    Address: "Indirizzo", //地址
    CountyCity: "Contea/Città", //县/市
    ProvinceState: "Provincia/Stato", //省/州
    CountryRegion: "Paese/Regione", //国家/地区
    ZipCode: "CAP", //邮政编码
    Website: "Sito web", //网站
    Email: "Email", //电邮
    Tel: "Tel", //电话
    LastUpdate: "Ultimo aggiornamento", //最近更新
    DataSource: "Fonte dati", //数据来源
    LegalStatus: "Stato giuridico", //法定状况
    CoID: "ID società", //公司ID
    CompanyType: "Tipo di società", //公司类型
    RegistrationDate: "Data di registrazione", //注册日期
    RegistrationStatus: "Stato di registrazione", //注册状态
    Listed: "Quotato", //上市信息
    CurrentOpperations: "Operazioni correnti", //经营状况
    IndustryCode: "Codice di settore", //行业代码
    BusinessActivities: "Attività commerciali", //主营业务
    NoofEmployees: "Numero di dipendenti", //员工数量
    NoofShareholders: "Numero di azionisti", //股东数量
    Management: "Direzione", //管理状况
    Performance: "Prestazione", //业绩表现
    Revenue: "Fatturato", //收入
    Assets: "Attività", //资产
    ProfitLoss: "Utile/Perdita", //利润
    Growth: "Crescita", //公司增长
    Competitiveness: "Competitività", //竞争力
    CreditOpinion: "Opinione creditizia", //信用状况
    CreditRating: "Rating creditizio", //信用评级
    CreditScore: "Punteggio creditizio", //信用评分
    ESGRating: "Rating ESG", //ESG 评级
    Solvency: "Solvibilità", //偿还能力
    Sanctions: "Sanzioni", //全球制裁
    CoName: "Nome dell'azienda",
    RegName: "Nome registrato",
  },
  Profile: {
    CompareCompanies: "Confronta le aziende",
    AddaCompany: "Aggiungi un'azienda",
    SubjectCompany: "Azienda oggetto di analisi", //目标公司
    ComparisonCompany: "Comparatore Azienda",
    CompanyProfile: "Profilo aziendale", //基本资料
    CompanyName: "Nome dell'azienda", //公司名称
    NativeName: "Nome nativo", //当地名称
    CompanyID: "ID azienda", //公司 ID
    VATNumber: "Partita IVA", //VAT号
    StockCode: "Codice azionario", //股票代码
    Listed: "Quotato", //上市日期
    RegistrationDate: "Data di registrazione", //注册日期
    LegalForm: "Forma giuridica", //公司性质
    CompanyType: "Tipo di società", //公司类型
    LegalStatus: "Stato giuridico", //注册状态
    Jurisdiction: "Giurisdizione", //司法管辖区
    RegisteredAddress: "Sede legale", //注册地址
    ProvinceState: "Provincia/Stato", //省/州
    CountryRegion: "Paese/Regione", //国家/地区
    ZipCode: "CAP", //邮政编码
    OperatingAddress: "Sede operativa", //经营地址
    LastUpdate: "Ultimo aggiornamento", //最近更新
    DataSource: "Fonte dati", //数据来源
    History: "Cronologia", //历史记录
    RegisteredCapital: "Capitale sociale",
    PaidinCapital: "Capitale versato",
    CountyCity: "Contea/Città",
    OtherName: "Altro nome",
  },
  Ownership: {
    TotalPartiesInvolved: "Numero totale di parti coinvolte",
    UltimateBeneficiaryOwner: "Titolare Effettivo Ultimo (UBO)", //最终受益人
    NaturalPersonShareholder: "Azionista persona fisica", //涉及自然人股东
    CorporateShareholders: "azionisti aziendali", //涉及法人股东
    ShareholderLevel: "Livello di azionista", //股东层级x
    Name: "Nome", //名称
    Country: "Paese", //国家/地区
    Location: "Luogo", //地点
    Type: "Tipo", //类型
    Shares: "Azioni", //股份
    Relation: "Rapporto", //关系
    RelatedCompany: "Società collegate",
    CompanyShareholders: "Azionisti della società",
    NGOShareholders: "Azionisti delle ONG",
    SubjectInvestments: "Investimenti del soggetto",
  },
  RelatedCompanies: {
    Total: "Entità totali", //相关公司总计
    Countries: "Paesi", //国家/地区
    Branches: "Filiali", //分支机构
    RelatedComp: "Società collegate", //关联公司
    Name: "Nome", //名称
    Country: "Paese", //国家/地区
    Location: "Sede", //地点
    Type: "Tipo", //类型
    Relationship: "Relazione", //关系
    BranchOffices: "Uffici distaccati",
    Subsidiaries: "Società controllate",
  },
  Management: {
    Management: "Direzione", //管理层
    ContactInfo: "Informazioni di contatto", //联系人信息
    Countries: "Paesi", //国家/地区
    Name: "Nome", //名称
    Position: "Posizione", //职位
    Department: "Dipartimento", //部门
    Country: "Paese", //国家/地区
    ShareholderNot: "Azionista o meno", //是否股东
    Relation: "Relazioni", //关系
    Verification: "Verifica", //已验证
    Searchmoreemails: "Cerca altre email", //搜索更多电邮
    Roles: "Ruoli", //角色
    EducationLevel: "Livello di istruzione", //教育程度
    Phone: "Telefono", //电话
    Email: "Email", //电邮
    Verified: "Verificato", //已验证
    Searchmore: "Cerca altre email su altre aziende", //搜索更多其他公司的电邮
    Pleaseentername: "Per favore inserisci il nome",
    PleaseenterWebsite: "Inserisci il nome dell'azienda o il dominio",
    UserSelfVerification: "Autoverifica dell'utente",
    Userverified: "Utente verificato",
    Source: "Origine",
  },
  Operations: {
    LineofBusiness: "Settore di attività", //业务范围
    BusinessTerritories: "Aree commerciali", //业务区域
    ImportExport: "Importazione ed esportazione", //进出口信息
    Viewtradeinfo: "Visualizza ulteriori informazioni commerciali", //查看更多贸易信息
    ProductsServices: "Prodotti/Servizi", //产品/服务
    Products: "Prodotti", //产品
    ProductImage: "Immagine del prodotto", //产品图片
    ProductName: "Nome del prodotto", //产品名称
    ProductDescription: "Descrizione del prodotto", //产品描述
    Details: "Dettagli", //详情
    Addproductinformation: "Aggiungi informazioni sul prodotto", //添加产品信息
    Showcaseyourcompany:
      "Se desideri mostrare al pubblico i prodotti o i servizi della tua azienda, puoi aggiungere qui le informazioni sui prodotti e sui servizi. Questo è un ottimo modo per promuovere la tua attività. Una volta esaminato il tuo invio, i tuoi dati verranno pubblicati.",
  },
  Locations: {
    CoName: "Nome dell'azienda", //业务范围
    Relationship: "Relazione", //关系
    Type: "Tipo", //类型
    Country: "Paese", //国家/地区
    Location: "Sede", //地点
    Address: "Indirizzo", //地址
    Edit: "Modifica", //编辑
    CompanyLocatiionsMap: "Sedi dell'azienda sulla mappa", //地图中的公司位置
    Selectaddresstype: "Seleziona il tipo di indirizzo", //选择地址类型
    Subjectcompany: "Società interessata", //目标公司
    Subsidiary: "Filiale", //子公司
    RegisteredAddress: "Sede legale", //注册地址
    OperationAddress: "Indirizzo operativo", //运营地址
    All: "Tutti", //全部
    Showlocation: "Mostra posizioni",
  },
  Industry: {
    IndustryTitle: "Titolo del settore", //IndustryTitle
    IndustryDescription: "Descrizione del settore", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "Descrizione ISIC", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "Descrizione NACE", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "Descrizione NAICS", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "Descrizione CSIC", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "Descrizione AAAIC", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "Descrizione GICS", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Importo totale delle importazioni", //进口总额
    TopImportCountry: "Paese di importazione principale", //最大进口国家/地区
    TopImportProduct: "Prodotto di importazione principale", //最大进口产品
    TotalExport: "Importo totale delle esportazioni", //出口总额
    TopExportCountry: "Paese di esportazione principale", //最大出口国家/地区
    TopExportProduct: "Prodotto di esportazione principale", //最大出口产品
    TradeVolume: "Volume commerciale", //贸易额
    ImportShipments: "Spedizioni di importazione", //进口量
    ExportShipments: "Spedizioni di esportazione", //出口量
    ImportCountries: "Paesi di importazione", //进口国家/地区
    ExportCountries: "Paesi di esportazione", //出口国家/地区
    ImportVolume: "Volume di importazione", //进口量
    ExportVolume: "Volume di esportazione", //出口量
    Suppliers: "Principali fornitori", //主要供应商
    Shipments: "Per numero di spedizioni", //按出货量
    Buyers: "Principali acquirenti", //主要买家
    ImportQuantity: "Quantità di importazione", //进口数量
    IncreaseDecreasexRate: "Tasso di aumento/diminuzione", //增/减率
    ExportQuantity: "Quantità di esportazione", //出口数量
    ImportsExportsRecords: "Registri di importazioni ed esportazioni", //进出口记录
    Date: "Data", //日期
    Product: "Prodotto", //产品
    HSCode: "Codice SA", //HS 编码
    BuyerName: "Nome dell'acquirente", //买家名称
    Destination: "Destinazione", //目的地
    SupplierName: "Nome del fornitore", //供应商名称
    Origin: "Origine", //原产地
    Amount: "Importo (USD)", //金额
    Details: "Dettagli", //详情
    Imports: "Importazioni",
    Exports: "Esportazioni",
    Shipments2: "Spedizioni",
    value2: "valore",
    value: "Per numero di valore",
    viewmoretradeinfo: "visualizzare ulteriori informazioni commerciali",
    SearchHSCode: "Cerca codice HS",
    Selectdate: "Seleziona la data",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      'Questo grafico illustra le relazioni di "acquisto da" e "vendita a" della società in questione. Maggiore è il volume, più spesso è il tubo.',
  },
  ShippingOrderDetails: {
    Date: "Data",
    MasterBillofLading: "Polizza di carico principale",
    Source: "Origine",
    BillNo: "N. fattura",
    ImporterBuyer: "Importatore / Acquirente",
    ExporterSeller: "Esportatore / Venditore",
    Name: "Nome",
    Address: "Indirizzo",
    Country: "Paese",
    Contact: "Contatto",
    Email: "Email",
    CargoInfo: "Informazioni sul carico",
    HSCode: "Codice SA",
    Quantity: "Quantità",
    WeightUnit: "Unità di peso",
    ProductDescription: "Descrizione del prodotto",
    Amount: "Importo (USD)",
    QuantityUnit: "Unità di quantità",
    Weight: "Peso",
    HSDescription: "Descrizione SA",
    Incoterms: "Incoterms",
    ShippingInfo: "Informazioni sulla spedizione",
    Vessel: "Nave",
    Consignee: "Destinatario",
    MeansofTransport: "Mezzo di trasporto",
    CountryofOrigin: "Paese di origine",
    Voyage: "Viaggio",
    Notifier: "Notificatore",
    CountryofDestnation: "Paese di destinazione",
    AddressofOrigin: "Indirizzo di origine",
    Shipper: "Mittente",
    AddressofDestnation: "Indirizzo di destinazione",
    Container: "Container",
    ContainerID: "ID container",
    ContainerType: "Tipo di container",
    ContainerDescDode: "Descrizione container",
    ContainerSize: "Dimensioni container",
    ImportExport: "Importatore/Esportatore",
    Imports: "Importazioni",
    Exports: "Esportazioni",
  },
  FinancialHighlight: {
    Revenue: "Ricavi", //收入
    Profit: "Utili", //利润
    Growth: "Crescita", //增长
    CashFlowStatus: "Stato del flusso di cassa", //现金流状况
    FinancialStructure: "Struttura finanziaria", //融资结构
    CreditOpinion: "Opinione creditizia", //信用评估
    RiskIndicator: "Indicatore di rischio", //风险指标
    Solvencyindex: "Indice di solvibilità", //偿还指数
    Year: "Anno", //年份
    Change: "Variazione", //变化
    NetProfit: "Utile netto",
    TotalAssets: "Totale attivo",
    Equity: "Patrimonio netto",
    GrossMargin: "Margine lordo",
    ProfitMargin: "Margine di profitto",
    ReturnonEquity: "Rendimento del capitale proprio",
    CurrentRatio: "Indice di liquidità",
    DebtRatio: "Indice di indebitamento",
    FinancialHighlights: "Dati finanziari delle società collegate", //关联公司财务数据
    FinancialHighlightsTitle:
      "Dati finanziari salienti delle società collegate", //关联公司财务摘要
    CompanyName: "Nome della società", //公司名称
    CompanyID: "ID della società", //公司ID
    Country: "Paese", //国家/地区
    CompanyStatus: "Stato della società", //公司状态
    Cancel: "Annulla", //取消
    Select: "Seleziona",
    Relations: "Relazioni", //关系
    Financialperformancedata:
      "I dati sulla performance finanziaria vengono raccolti da varie fonti governative e agenzie locali di segnalazione del credito. Inoltre, per calcolare e modellare i dati vengono utilizzate ricerche di mercato e di settore. Per informazioni più dettagliate sulle operazioni effettive e sull'analisi delle prestazioni, contatta il nostro team di assistenza per richiedere un rapporto di due diligence aziendale.",
    Whenthesubjectsdata:
      "Quando i dati del soggetto sono insufficienti o sei interessato a ottenere maggiori informazioni sul tuo cliente, questa piattaforma offre una visione completa di tutte le entità correlate all'argomento. Ciò include gli azionisti della società del soggetto, le società collegate e altro ancora.",
    Byprovidingyou:
      "Fornendoti una prospettiva più ampia, questa piattaforma ti consente di effettuare valutazioni più informate e acquisire una comprensione più profonda del tuo argomento.",
    PleaseSelectTheYeartoDisplay: "Selezionare l'anno da visualizzare",
    SelectUptoThreeYears: "Seleziona Fino a tre anni",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Indici di redditività",
    Year: "Anno",
    Change: "Variazione",
    Returnonequity: "Rendimento del capitale proprio",
    Returnonassets: "Rendimento delle attività",
    Profitmargin: "Margine di profitto",
    Grossmargin: "Margine lordo",
    OperatingRatios: "Indici operativi",
    Assetsturnover: "Rotazione delle attività",
    Stockturnover: "Rotazione delle scorte",
    Salesperiod: "Periodo di vendita",
    Collectionperiod: "Periodo di incasso",
    Creditperiod: "Periodo di credito",
    StructuralRatios: "Indici di struttura",
    Currentratio: "Indice di liquidità",
    Quickratio: "indice di liquidità immediata",
    Shareholdersliquidityratio: "Indice di liquidità degli azionisti",
    Solvencyratio: "Indice di solvibilità",
    Debtratio: "Indice di indebitamento",
    ProductivityRatios: "Indici di produttività",
    Profitperemployee: "Utile per dipendente",
    Operatingrevenueperemployee: "Ricavi operativi per dipendente",
    Shareholdersfundsperemployee: "Patrimonio netto per dipendente",
    Totalassetsperemployee: "Totale attivo per dipendente",
    GrowthRatios: "Indici di crescita",
    Salesgrowthrate: "Tasso di crescita delle vendite",
    Netprofitgrowthrate: "Tasso di crescita dell'utile netto",
    Totalassetsgrowthrate: "Tasso di crescita del totale attivo",
    FinancialHighlights: "Dati finanziari delle società collegate", //关联公司财务数据
    RatioAnalysis: "Analisi degli indici delle società collegate", //关联公司比率分析
    CompanyName: "Nome della società",
    CompanyID: "ID della società",
    Country: "Paese",
    CompanyStatus: "Stato della società",
    Relations: "Relazioni",
  },
  IndustryNorms: {
    IndustryStatistics: "Statistiche di settore",
    ofcompaniesintheIndustry: "Numero di aziende nel settore",
    oflistedCompaniesintheIndustry: "Numero di aziende quotate nel settore",
    oflargecompaniesintheIndustry: "Numero di grandi aziende nel settore",
    ofSMEsintheIndustry: "Numero di PMI nel settore",
    ofcompaniesinsample: "Numero di aziende nel campione",
    ofcompaniesinloss: "Numero di aziende in perdita",
    Observations: "Osservazioni",
    AverageValue: "Valore medio",
    MedianValue: "Valore mediano",
    MaximumValue10: "Valore massimo 10%",
    MinimumValue10: "Valore minimo 10%",
    SubjectCompany: "Azienda in questione",
    YearsinBusiness: "Anni di attività",
    TotalAssets: "Totale attivo",
    TotalEquity: "Patrimonio netto totale",
    Revenue: "Ricavi",
    NetEarning: "Utile netto",
    Returnonassets: "Rendimento delle attività",
    Performance: "Performance",
    ProfitabilityRatios: "Indici di redditività",
    Returnonequity: "Rendimento del capitale proprio",
    Grossmargin: "Margine lordo",
    OperatingRatios: "Indici operativi",
    Stockturnover: "Rotazione delle scorte",
    Accountsreceivableturnover: "Rotazione dei crediti commerciali",
    Assetsturnover: "Rotazione delle attività",
    Totalassetturnover: "Rotazione delle attività totali",
    StructuralRatios: "Indici di struttura",
    Currentratio: "Indice di liquidità",
    Quickratio: "indice di liquidità immediata",
    Shareholdersliquidityratio: "Indice di liquidità degli azionisti",
    GrowthRatios: "Rapporti di crescita",
    Salesgrowthrate: "Tasso di crescita delle vendite",
    Netprofitgrowthrate: "Tasso di crescita dell'utile netto",
    Totalassetsgrowthrate: "Tasso di crescita del totale attivo",
  },
  Lawsutis: {
    Litigations: "Contenziosi",
    Date: "Data",
    CaseType: "Tipo di caso",
    Title: "Titolo del caso",
    CaseNo: "Caso n.",
    CauseofAction: "Causa dell'azione",
  },
  News: {
    Date: "Data", //日期
    Title: "Titolo", //标题
    Source: "Impatto", //来源
    Impact: "Impatto", //影响
    Searchcompanies: "Cerca altre notizie su altre aziende", //国家/地区
    SearchforTitle: "Cerca titolo",
    CompanyName: "Nome dell'azienda",
    Industry: "Industria",
    Subjects: "Soggetti",
    NewsTypes: "Tipi di notizie",
    ByDate: "Per data",
    SelectCompanyName: "Seleziona il nome dell'azienda",
    SelectIndustry: "Seleziona Industria",
    SelectSubjects: "Seleziona le materie",
    SelectNewsType: "Seleziona il tipo di notizia",
    Negative: "Negativo",
    Positive: "Positiva",
  },
  Sanctions: {
    Potentialcompliance: "Sono stati rilevati potenziali rischi di conformità", //检测到潜在合规风险
    SeachbuttonNo: "Non è stato rilevato nulla di dannoso per questa azienda", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'Per cercare altri record di sanzioni, fare clic sul pulsante "Cerca sanzioni".', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Cerca sanzioni", //搜索制裁
    ViewDetails: "Visualizza dettagli", //查看详情
    Sanctions: "Sanzioni", //制裁
    Potentialcompliancerisks: "Potenziali rischi di conformità", //潜在合规风险
    IDInfo: "Informazioni ID", //ID 信息
    IDType: "Tipo ID", //ID 类型
    IDDescription: "Descrizione ID", //ID 描述
    SanctionList: "Elenco sanzioni", //制裁名单
    SanctionListInvolved: "Elenco sanzioni interessato", //涉及的制裁名单
    StartDate: "Data di inizio", //生效日期
    EndDate: "Data di fine", //结束日期
    SourceList: "Elenco fonti", //来源名单
    SourceName: "Nome fonte", //来源名称
    ProfileNotes: "Note profilo", //主体资料
    Link: "Link", //链接
    Name: "Nome", //名称
    AssociationList: "Elenco delle associazioni",
    AssociationID: "Identificativo dell'associazione",
    AssociationType: "Tipo di associazione",
  },
  CreditOpinion: {
    CreditAssessment: "Valutazione del merito creditizio",
    CreditAssessmentfromtheRelatedCompanies:
      "Valutazione del merito creditizio delle società collegate",
    Year: "Anno",
    CreditRating: "Rating creditizio",
    LocalCreditScore: "Punteggio creditizio locale",
    ProbabilityofDefault: "Probabilità di default",
    SolvencyIndex: "Indice di solvibilità",
    CreditLine: "Linea di credito",
    RiskIndicator: "Indicatore di rischio",
    RelatedCreditAssessment: "Valutazione del merito creditizio correlato",
    CompanyName: "Nome della società",
    CompanyID: "ID della società",
    Country: "Paese",
    CompanyStatus: "Stato della società",
    Relations: "Relazioni",
    Cancel: "Annulla", //取消
    Select: "Seleziona",
    CreditAssessmentMessage1:
      "Quando i dati del soggetto sono insufficienti o sei interessato a ottenere maggiori informazioni sul tuo cliente, questa piattaforma offre una visione completa di tutte le entità correlate all'argomento. Ciò include gli azionisti della società del soggetto, le società collegate e altro ancora.",
    CreditAssessmentMessage2:
      "Fornendoti una prospettiva più ampia, questa piattaforma ti consente di effettuare valutazioni più informate e acquisire una comprensione più profonda del tuo argomento.",
    LocalCreditRating: "Rating del credito locale",
    LocalCreditRatingDetail:
      "Spinto dalla potenza dei big data, 3ARating è un sistema di rating quantitativo per le aziende private. Si tratta di uno sforzo di collaborazione tra 3ACredit e Creditreform Rating. Il modello di rating è costruito sulla base di una valutazione globale di vari fattori chiave, inclusi fattori non finanziari, fattori finanziari, record negativi e considerazioni specifiche del settore. Il modello di rating presenta un impressionante coefficiente Gini, che ne indica la robustezza e l’affidabilità. 3ARating copre una gamma di rating, dal rating più alto, 3A1, alla classe di rating più bassa, 3A19.",
    CreditScore: "Punteggio di credito",
    CreditScoreDetail:
      "I punteggi di credito sono calcolati su una scala da 1 a 100, in base al rating di credito ottenuto dalle autorità locali. Un punteggio più alto indica una migliore affidabilità creditizia.",
    PossibilityofDefault: "Possibilità di default (PD)",
    PossibilityofDefaultDetail:
      "La possibilità di default (PD) è uno strumento utile per la valutazione del rischio, concentrandosi sulla valutazione della liquidità a breve termine.",
    SolvencyIndexSI: "Indice di solvibilità (SI)",
    SolvencyIndexSIDetail:
      "L'indice di solvibilità (SI) è un indicatore di allarme rapido altamente efficace e affidabile che consente una rapida valutazione della solvibilità dei partner commerciali. Un valore SI più alto indica un rischio di insolvenza più elevato da parte del cliente. L'SI varia da 100, che è considerato un punteggio eccellente, a 600, dove sono presenti caratteristiche altamente negative.",
    ExternalRating: "Valutazione esterna",
    DefaultProbability: "Probabilità predefinita (Pd1Year)",
    Rating: "3ARotazione (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Selezionare l'anno da visualizzare",
    SelectUptoThreeYears: "Seleziona Fino a tre anni",
    HighRisk: "Alto rischio",
    Medium: "Mezzo",
    Moderate: "Moderare",
    Average: "Gemiddeld",
    LowerThanAvg: "Inferiore alla media",
    LowRisk: "Basso rischio",
    CreditOpinion: "Opinione sul credito",
  },
  IndustryStatistics: {
    SubjectCompany: "Azienda",
    Country: "Paese",
    Compare: "Confronta",
    Industry: "Settore",
    CompanyType: "Tipo di azienda",
    CompanySize: "Dimensioni dell'azienda",
    CompanyStatus: "Stato dell'azienda",
    YearsinBusiness: "Anni di attività",
    CompanyRating: "Valutazione dell'azienda",
    Liquidity: "Stato del flusso di cassa",
    NoofcoinIndustry: "N. di co. nell'industria",
    IndustryRating: "Valutazione del settore",
    Profitability: "Redditività",
    Growth: "Crescita",
    FinancialStructurt: "Struttura finanziaria",
    Solvency: "Solvenza",
    SearchCountry: "Cerca Paese",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Analisi di settore",
    GeographicAnalysis: "Analisi geografica",
    CompanyTypeAnalysis: "Analisi del tipo di azienda",
    BiusinessScaleAnalysis: "Analisi della scala di business",
    HistoryAnalysis: "Analisi storica",
    NormalDistribution: "Distribuzione normale",
    SubjectCompany: "Azienda oggetto di studio",
    Probabilityofthesubjectratinginitsindustry:
      "Probabilità del rating dell'azienda oggetto di studio nel suo settore",
    Maximum: "Massimo 10%",
    Mean: "Media",
    Average: "Media",
    Minimum: "Minimo 10%",
    RatingDistribution: "Distribuzione del rating",
    Revenue: "Fatturato",
    Earning: "Utile",
    TotalAssets: "Totale attivo",
    Subjectratinginitsindustrybyfinancialindicators:
      "Rating dell'azienda oggetto di studio nel suo settore in base agli indicatori finanziari",
    Best: "Migliore",
    Worst: "Peggiore",
    Rankingofsubject:
      "Classificazione del rating dell'azienda oggetto di studio nel settore",
    Industy: "Settore",
    Percentilerank:
      "Posizione percentile: % di aziende che hanno ottenuto un punteggio pari o inferiore al rating dell'azienda oggetto di studio",
    Historicaldevelopmentofsubject:
      "Sviluppo storico del rating dell'azienda oggetto di studio nel suo settore",
    IndustryAverage: "Media del settore",
    SubjectRatingChanges:
      "Variazioni del rating dell'azienda oggetto di studio",
    CreditScore: "Punteggio di credito",
    NOofCompanies: "N. di società",
    ofCompanies: "% delle aziende",
    CreditRating: "Valutazione del credito",
    CompanySize: "Dimensioni dell'azienda",
    YearsinBusiness: "Anni di attività",
    SubjectsIndustryConcentrationAnalysis:
      "Analisi della concentrazione del settore del soggetto",
    GeographicdistributionofSubjectsratingintsindustry:
      "Distribuzione geografica della valutazione del Soggetto nel suo settore",
    GeographicdistributioninSubjectindustry:
      "Distribuzione geografica nel settore del Soggetto",
    RatingDistributioninSubjectsLocation:
      "Distribuzione della valutazione nella posizione del soggetto",
    Ratinganalysisofcompanies:
      "Analisi del rating di aziende dello stesso settore con anni di attività diversi",
    Subjectsratinghistory:
      "Cronologia delle valutazioni del soggetto confrontata con i suoi pari con la stessa storia",
    Ratingrankingofcompanieswithsamehistory:
      "Classifica di rating delle aziende con la stessa storia",
    Ratingstatistics:
      "Statistiche di rating delle aziende con gli stessi anni di attività",
    Subjectratingcomparing:
      "Valutazione del soggetto rispetto alle società pari con il",
    Subjectratinginitsgroup: "Valutazione del soggetto nel suo gruppo:",
    Analysisbasedonnature:
      "Analisi basata sulla natura delle aziende del settore in questione",
    Subjectratingpositioninitscompanytype:
      "Posizione di rating del soggetto nella sua tipologia aziendale",
    Ratingstatisticsofcompanies:
      "Statistiche di valutazione delle aziende dello stesso settore",
    Ratinganalysisofcompanies:
      "Analisi del rating di aziende di diverse dimensioni dello stesso settore",
    Probabilityofsubjectrating:
      "Probabilità di classificazione del soggetto nel suo settore entro le sue dimensioni",
    Subjectratingcomparingwithindustry:
      "Valutazione del soggetto rispetto ai suoi colleghi nel suo settore",
    RatingRankingofthecompanies:
      "Rating Classifica delle aziende della stessa dimensione nello stesso settore",
    Ratingstatisticsofcompanies:
      "Statistiche di rating di aziende della stessa dimensione e dello stesso settore",
    Rank: "Rango",
    Rating: "rating",
    CompanyType: "Tipo di azienda",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Posizione di mercato",
    Revenus: "Ricavi",
    NetEarnings: "Utili netti",
    NetAssets: "Attività nette",
    TotalAssets: "Totale attivo",
    Employees: "Dipendenti",
    Mean: "Media",
    Average: "Media",
    Maximum: "Massima (10%)",
    Worst: "Peggiore (10%)",
    Subjectcompany: "Azienda oggetto di analisi",
    PerformanceComparison: "Confronto delle performance",
    ProfitabilityRatios: "Indici di redditività",
    Grossmargin: "Margine lordo",
    Returnonassets: "Rendimento delle attività",
    Returnonequity: "Rendimento del capitale proprio",
    OperatingRatios: "Indici operativi",
    Stockturnover: "Rotazione delle scorte",
    Assetsturnover: "Rotazione delle attività",
    Currentassetturnoverrate: "Tasso di fatturato corrente delle attività",
    Collectionperiod: "Periodo di incasso",
    GrowthRatios: "Indici di crescita",
    Totalassetsgrowthrate: "Tasso di crescita del totale attivo",
    Salesgrowthrate: "Tasso di crescita delle vendite",
    Netprofitgrowthrate: "Tasso di crescita dell'utile netto",
    StructuralRatios: "Indici di struttura",
    Debtratio: "Indice di indebitamento",
    Quickratio: "indice di liquidità immediata",
    Currentratio: "Indice di liquidità",
  },
  AccountCenterMenu: {
    SearchinSettings: "Cerca in Impostazioni", //在“设置”中搜索
    Account: "Account", //账户
    MyAccount: "Il mio account", //我的账户
    ContactInfo: "Informazioni di contatto", //联系信息
    AccountSecurity: "Sicurezza dell'account", //账户安全
    OrganizationalManagement: "Gestione organizzativa", //组织管理
    UserGroup: "Gruppo utenti", //用户组
    User: "Utente", //用户
    Role: "Ruolo", //角色
    MyDatabase: "Il mio database", //我的数据库
    MyUsage: "Il mio utilizzo", //我的使用情况
    CompaniesViewed: "Aziende visualizzate", //查看过的公司
    ReportsDownloaded: "Report scaricati", //下载的报告
    ReportUpdatesOrdered: "Aggiornamenti report ordinati", //订购的报告更新
    BillingandPayment: "Fatturazione e pagamento", //账单和付款
    BillRecords: "Registri fatture", //账单记录
    PaymentRecords: "Registri pagamenti", //付款记录
    CreditDeductions: "Detrazioni credito", //信用扣款
    InvoicesDownloaded: "Fatture scaricate", //下载的发票
    UserSettings: "Impostazioni utente", //用户设置
    Messages: "Messaggi", //消息
    Notifications: "Notifiche", //通知
    HelpCenter: "Centro assistenza", //帮助中心
    FAQ: "FAQ", //常见问题
    Privacy: "Privacy", //隐私
    Terms: "Termini", //条款
    ReportIssues: "Segnala problemi", //报告问题
    UserGuide: "Guida utente", //用户指南
    AboutCSI: "Informazioni su CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Ora di accesso", //登录时间
    SignOut: "Esci", //退出
    DeleteAccount: "Elimina account", //删除账户
    AccountID: "ID account", //账户ID
    Enteranewaddress: "Inserisci un nuovo indirizzo email", //输入新的电邮
    EnterVerificationCode: "Inserisci codice di verifica", //输入验证码
    SendverificationCode: "Invia codice di verifica", //发送验证码
    Password: "Password", //密码
    Originalpassword: "Password originale", //原始密码
    Newpassword: "Nuova password", //新密码
    Confirmnewpassword: "Conferma nuova password", //确认新密码
    AccountOwnership: "Titolare dell'account", //账户所有权
    IndividualAccount: "Account individuale", //个人账户
    GroupAccount: "Account di gruppo", //集团账户
    Organizationname: "Nome dell'organizzazione", //机构名称
    CountryRegion: "Paese/Regione", //国家/地区
    Address: "Indirizzo", //地址
    City: "Città", //城市
    ZipCode: "CAP", //邮政编码
    FirstName: "Nome", //名字
    LastName: "Cognome", //姓氏
    PhoneNumber: "Numero di telefono", //电话号码
    Email: "Email", //更改
    Change: "Modifica", //更改
    Save: "Salva", //保存
    Cancel: "Annulla", //取消
    LastLogin: "Ultimo accesso", //Last Login
    RecentLogin: "Accessi recenti", //登录尝试次数
    AverageLoginTime: "Tempo medio di accesso", //平均登录时间
    TotalLoginAttempts: "Tentativi di accesso totali", //登录尝试次数
    Registrationtime: "Ora di registrazione",
    Role: "Ruolo",
    Administrator: "Amministratore",
    Enterpriseusers: "Utenti aziendali",
    EditImage: "Modifica immagine",
    DeleteImage: "Elimina immagine",
  },
  ContactInfo: {
    ContactInfo: "Informazioni di contatto",
    FirstName: "Nome",
    LastName: "Cognome",
    PhoneNumber: "Numero di telefono",
    Email: "Email",
    CountryRegion: "Paese/Regione",
    AddressLine: "Indirizzo",
    City: "Città",
    ZipCode: "CAP",
    Alternativecontactperson: "Persona di contatto alternativa",
    Setascontactperson: "Imposta come persona di contatto",
    Edit: "Modifica",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Imposta le mie domande di sicurezza",
    Pleasechooseaquestion: "Scegli una domanda",
    Pleaseentertheanswertothequestion: "Inserisci la risposta alla domanda",
    SessionTimeoutAutomaticLogoutSettings:
      "Timeout sessione: Impostazioni di disconnessione automatica",
    Thesystemwillautomatically:
      "Il sistema ti disconnetterà automaticamente dopo un periodo di inattività. Il timeout predefinito è impostato su 5 minuti, ma puoi modificarlo in base alle tue esigenze.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Numero totale di aziende ricercate",
    TotalNumberofCompaniesCollected: "Numero totale di aziende raccolte",
    TotalNumberofUpdateReportsOrdered:
      "Numero totale di report di aggiornamento ordinati",
    Date: "Data",
    UserName: "Nome utente",
    CompanyName: "Nome azienda",
    Status: "Stato",
    UsageType: "Tipo di utilizzo",
    Entercompanyname: "Inserisci il nome dell'azienda",
    Download: "Scarica",
  },
  OrganizationalManagement: {
    GroupName: "Nome del gruppo",
    ParentGroupName: "Nome del gruppo padre",
    Organization: "Organizzazione",
    GroupID: "ID gruppo",
    GroupStatus: "Stato del gruppo",
    Operation: "Operazione",
    NewlyBuilt: "Nuova creazione",
    UserAccount: "Account utente",
    Role: "Ruolo",
    AccountStatus: "Stato dell'account",
    RoleName: "Nome del ruolo",
    Position: "Posizione",
    RoleStatus: "Stato del ruolo",
    Valid: "Valido",
    Invalid: "Non valido",
    PermissionSettings: "Impostazioni autorizzazioni",
    ShowMore: "Mostra altro",
    Search: "Cerca",
    Cancel: "Annulla",
    Confirm: "Confermare",
    NewGroup: "NuovoGruppo",
    EnterGroupName: "Inserisci il nome del gruppo",
    NumberofGroups: "Numero di gruppi",
    Groups: "Gruppi",
    Roles: "Ruoli",
    NewRoles: "Nuovi ruoli",
    EnterNewRole: "Inserisci il nuovo ruolo",
    Users: "Utenti",
    EnterUserName: "Inserisci il nome utente",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Numero totale di ordini",
    TotalPaymentAmount: "Importo totale del pagamento",
    TotalUsedCredits: "Totale crediti utilizzati",
    Date: "Data",
    UserAccount: "Account utente",
    CompanyName: "Nome dell'azienda",
    OrderNo: "Numero d'ordine",
    OrderType: "Tipo di ordine",
    OrderStatus: "Stato dell'ordine",
    Download: "Scarica",
    PaymentAmount: "Importo del pagamento",
    Contactus: "Contattaci",
    DownloadInvoice: "Scarica fattura",
    CreditUsage: "Utilizzo del credito",
    ReportOrderStatus: "Report sullo stato dell'ordine",
    CompanyID: "ID azienda",
    CountryRegion: "Paese/Regione",
    AddressLine: "Riga indirizzo",
    City: "Città",
    ZipCode: "CAP",
    FirstName: "Nome",
    LastName: "Cognome",
    PhoneNumber: "Numero di telefono",
    Email: "Email",
    BankAccountHolderName: "Nome del titolare del conto bancario",
    BeneficiaryBankName: "Nome della banca beneficiaria",
    SWIFTCODE: "CODICE SWIFT",
    AccountNumber: "Numero di conto",
    BeneficiaryBankAddress: "Indirizzo della banca beneficiaria",
    ABA: "ABA (Codice di avviamento bancario)",
    IBANnumber: "Codice IBAN",
    StartingMonth: "Mese di inizio",
    EndMonth: "Fine mese",
    InvoiceInfo: "Informazioni sulla fattura",
  },
  UserSettings: {
    LanguageandLocation: "Lingua e posizione",
    Language: "Lingua",
    Selectyourpreferedlanguage: "Seleziona la tua lingua preferita",
    Location: "Posizione",
    Selectyourlocation: "Seleziona la tua posizione",
    NotificationSetting: "Impostazioni di notifica",
    EmailNotification: "Notifica via email",
    ServiceUpdates: "Aggiornamenti del servizio",
    CompanyNews: "Notizie aziendali",
  },
  AddCredit: {
    Customizeyourplan: "Personalizza il tuo piano come preferisci",
    Silver: "Argento",
    Gold: "Oro",
    Enterpris: "Impresa",
    Credit: "Credito",
    Remaining: "Restanti {0} punti",
    Usermonth: "utente/mese",
    Useryear: "utente/anno",
    PaidMonthlyRenews:
      "Pagamento mensile, non è necessario il rinnovo automatico",
    PaidAnnuallyRenews:
      "Pagamento annuale, non è necessario il rinnovo automatico",
    ForFullSupport: "per il pieno supporto alle tue esigenze",
    Each: "ciascuno",
    CreditsCharged:
      "I crediti addebitati sul tuo account non scadranno mai finché il tuo account rimarrà attivo.",
    PaidMonthly: "pagato mensilmente",
    PaidAnnually: "pagato annualmente",
    BuyNow: "acquista ora",
    ContactNow: "contatta ora",
    SearchCompanies:
      "Cerca le aziende e ottieni un accesso immediato ai dati aziendali che includono",
    EverythinginSilverPackage: "Tutto nel pacchetto Silver, in più",
    CreditsCanbeUsed:
      "I crediti possono essere utilizzati per più servizi dati, inclusi i seguenti",
    UnlimitedAdvancedSearch: "Ricerca avanzata illimitata",
    ViewCompanyProfile: "Visualizza il profilo aziendale",
    CompanyOwnershipStructure: "Assetto proprietario della società",
    CompanyFamilyTree: "Albero genealogico aziendale",
    Companymanagement: "Gestione aziendale",
    CompanyContactsinfo: "Informazioni sui contatti dell'azienda",
    BusinessActivities: "Attività commerciali",
    IndustryBasics: "Nozioni di base del settore",
    ImportExportRecords: "Importa ed esporta record",
    CompanyPublications: "Pubblicazioni aziendali",
    CompanyNews: "Novità aziendali",
    DownloadOnlineReport: "Scarica il rapporto on-line",
    ManagementDetails: "Dettagli di gestione",
    ShareholderPenetration: "Penetrazione azionaria (UBO)",
    Financialinfo: "Informazioni finanziarie",
    FinancialAnalysis: "Analisi finanziaria",
    CreditAssessment: "Valutazione del credito",
    IndustryAnalysis: "Analisi del settore",
    MarketAnalysis: "Analisi di mercato",
    SupplyChaininfo: "Informazioni sulla catena di fornitura",
    CheckSanctions: "Controlla le sanzioni",
    CompanyComparison: "Confronto aziendale",
    DataExport: "Esportazione dei dati",
    MonitoringService: "Servizio di monitoraggio",
    DiscountForFreshUpdateReports: "Sconto per nuovi rapporti di aggiornamento",
    SearchCompany: "Cerca azienda",
    SearchLeads: "Cerca lead",
    SearchTrade: "Cerca commercio",
    SearchPeople: "Cerca persone",
    SearchCountry: "Cerca Paese",
    SearchNews: "Cerca notizie",
    SearchSanction: "Cerca sanzione",
    DataServices: "Servizi dati",
    APIPlans: "Piani API",
    VolumeDiscounts: "Sconti sulla quantità",
    GroupAccountsWithMultipleUsers: "Account di gruppo con più utenti",
    CustomizedPlans: "Piani personalizzati",
    FreshInvestigatedCreditReportsWorldwide:
      "Nuovi rapporti di credito esaminati in tutto il mondo",
    BusinessMonitoringServices: "Servizi di monitoraggio aziendale",
    BusinessProcessVerificationServices:
      "Servizi di verifica dei processi aziendali",
    VendorComplianceReports: "Rapporti di conformità del fornitore",
    MarketResearch: "Ricerche di mercato",
    More: "Altro…",
    Contactus: "Contattaci",
    PaymentMethod: "Metodo di pagamento",
    CreditCardNumber: "Numero di carta di credito",
    EnterCardNumber: "Inserisci il numero della carta",
    ExpirationDate: "Data di scadenza",
    Fullnameoncard: "Nome completo sulla carta",
    EnterFullname: "Inserisci il nome completo",
    EnterProvinceState: "Inserisci Provincia/Stato",
    CVCCode: "Codice CVC",
    EnterCVCCode: "Inserisci il codice CVC",
    TotalPurchase: "Acquisto totale",
    Agree1: 'Facendo clic su "Invia", accetti il ',
    Agree2: "Contratto di servizio e la privacy di CSI.",
    Submit: "Invia",
    Month: "Mese",
    Year: "Anno",
    Country: "Paese",
    ProvinceState: "Provincia/Stato",
    Cancel: "Annulla",
    IncorrectCreditCardNumberformat:
      "Formato del numero di carta di credito errato",
    IncorrectExpMonthformat: "Formato mese di scadenza errato",
    IncorrectExpYearformat: "Formato anno di scadenza errato",
    IncorrectFullNameformat: "Formato nome completo errato",
    IncorrectCountryformat: "Formato Paese errato",
    IncorrectProvinceStateformat: "Formato Provincia/Stato errato",
    IncorrectCVCCodeformat: "Formato del codice CVC errato",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Che tipo di errori stai segnalando?",
    Tellusmoreaboutyourproblems: "Descrivici meglio i tuoi problemi.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Desideri fornire uno screenshot o un file relativo al tuo problema?",
    Fillinyourcontactinformation: "Inserisci i tuoi dati di contatto",
    FirstName: "Nome",
    LastName: "Cognome",
    PhoneNumber: "Numero di telefono",
    Email: "Email",
    Edit: "Modifica",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " è la piattaforma completa per una gestione completa dei rischi aziendali. Forniamo analisi dettagliate su tutte le principali categorie di rischio per salvaguardare le vostre decisioni aziendali.",
    LegalRisk: "Rischio legale",
    LegalRiskInfo: "verificare la legittimità dell’azienda",
    OrganizationalRisk: "Rischio organizzativo",
    OrganizationalRiskInfo:
      "stabilità gestionale, complessità della struttura aziendale e trasparenza della proprietà.",
    OperationalRisk: "Rischio operativo",
    OperationalRiskInfo:
      "vulnerabilità della catena di fornitura, stato operativo ed esposizione geopolitica.",
    FinancialRisk: "Rischio di performance finanziaria",
    FinancialPerformanceRiskInfo:
      "tendenze di redditività, problemi di liquidità e salute del bilancio.",
    CreditRisk: "Rischio di credito",
    CreditRiskInfo:
      "affidabilità creditizia, cronologia dei pagamenti e probabilità di insolvenza.",
    ComplianceRisk: "Rischio di conformità",
    ComplianceRiskInfo:
      "rispetto delle sanzioni, delle normative AML e delle leggi specifiche del settore",
    SustainabilityRisk: "Rischio di sostenibilità",
    SustainabilityRiskInfo:
      "fattori ESG (ambientali, sociali, di governance) e impatti sulla reputazione.",
    IndustryRisk: "Rischio di settore",
    IndustryRiskInfo:
      "valuta la stabilità e le prospettive dell'intero settore di un'azienda.",
    LetBegin: "Iniziamo",
    AddcompaniesfromSearchResult:
      "Aggiungi aziende dai risultati della ricerca",
    AddcompaniesfromMyDatabase: "Aggiungi aziende dal mio database",
    Addcompaniesbyuploadmyownlist: "Aggiungi aziende caricando il mio elenco",
    Cancel: "Annulla",
    Confirm: "Confermare",
    UploadFiles: "Carica file",
    PleaseuploadyourfileinCVSformat: "Carica il tuo file in formato xlsx",
    Downloadxlsxtemplate: "Scarica il modello xlsx",
    Xcompanieswereuploadedsucessfuly: "{0} aziende sono state caricate correttamente.",
    Xcompanieswereidentifiedsucessfuly: "{0} aziende sono state identificate con successo.",
    Xcompanieswerenotmatched: "Le aziende {0} non sono state abbinate.",

    Uploadingfilefailed:
      "Caricamento del file non riuscito. Utilizza il modello e riprova.",
    ALL: "Tutti",
    SearchLeads: "Cerca potenziali clienti",
    LastUpdate: "Ultimo aggiornamento",
    CompanyID: "ID aziendale",
    CompanyType: "Tipo di azienda",
    RegistrationDate: "Data di registrazione",
    RegistrationStatus: "Stato di registrazione",
    Listed: "quotato in borsa",
    LegalStatus: "Stato legale",
    NoofShareholders: "Numero di azionisti",
    ShareholdingLayers: "Livelli degli azionisti",
    NoofCorporateShareholders: "Numero di azionisti aziendali",
    NoofNatualPersonShareholders: "Numero di azionisti persone fisiche",
    RelatedCompanies: "Società collegate",
    OrganizationalStatus: "Stato organizzativo",
    OperatingAddress: "Indirizzo operativo",
    IndustryCode: "Codice dell'industria",
    BusinessActivities: "Attività commerciali",
    NoofEmployees: "Numero di dipendenti",
    Management: "Gestione",
    CurrentOperations: "Operazioni correnti",
    Revenue: "fatturato",
    Assests: "Attività",
    ProfitLoss: "Profitto/Perdita",
    Liquidity: "Liquidità",
    Growth: "crescita",
    Performance: "Performance operativa",
    CreditRating: "Valutazione del credito",
    CreditScore: "Punteggio di credito",
    PausibilityofDefault: "Pausibilità del default (PD)",
    SolvencyIndex: "Indice di solvibilità",
    DebtCollection: "recupero crediti",
    CreditOpinion: "Parere di credito",
    CompanySanction: "di sanzioni aziendali",
    ProductSanction: "Sanzione del prodotto",
    ExportControl: "Controllo delle esportazioni",
    AntiCorruptionAntiBribery: "Anticorruzione e anti-concussione",
    Litigations: "contenziosi",
    NegativeNews: "Notizie negative",
    ESGScore: "Punteggio ESG",
    YearsinBusiness: "Anni di attività",
    Competitiveness: "Competitività",
    WorkingCapital: "Rischio di mercato",
    FinancialStructure: "Indice della catena di fornitura",
    Industrystatus: "Stato del settore",
    IndustryOutlook: "Prospettive del settore",
    NoofCompanies: "Numero di aziende",
    IndustryRanking: "Classifica del settore",
    IndustryConcentration: "PIL dell'industria %",
    IndustryCompetitiveness: "Competitività del settore",
    IndustryDevelopment: "Sviluppo industriale",
    CompanyName: "Nome dell'azienda",
    Legal: "Rischio legale",
    Organizational: "Rischio organizzativo",
    Operational: "Rischio operativo",
    Financial: "Rischio finanziario",
    Credit: "Rischio di credito",
    Compliance: "Rischi di conformità",
    Sustainability: "Sostenibilità",
    Industry: "Rischio industriale",
    Download: "Scarica",
    StartDate: "Data di inizio",
    EndDate: "Data di fine",
    Entercompanyname: "Inserisci il nome dell'azienda",
    Tryagain: "Riprova",
    //未对应
    Uploadyourlistofcompanies:
      "Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
    Choose: "Choose",
    Upload: "Upload",
    Uploading: "Uploading",
    Uploadwithamaximumfilesizeof1M:
      "(Upload up to 100 pieces of data at a time, with a maximum file size of 1M)",
    Tryagain: "Try again",
    Theuploadedonlyxlsx: "The uploaded file can only be in xls/xlsx format",
    RiskScanning: "Risk Scanning",
    Youhaveselectedatotalof: "You have selected a total of",
    Tostartriskscanning: "companies, click “confirm” to start risk scanning",
    Datascanningisinprogress: "Data scanning is in progress ...",
    ClearAll: "Clear All",
    SelectUpdateDate: "Select Last Update",
    UpdateStatus: "Update Status",
    Updated: "Updated",
    Notupdated: "Not updated",
    Updating: "Updating",
    SelectRiskValue: "Select Risk Value",
    ReSelectData: "Re Select Data",
    HistoricalData: "Historical Data",
    DiagnosticReport: "Diagnostic Report",
    Good: "Good",
    General: "General",
    Differ: "Differ",
    NotEvaluated: "Not Evaluated",
    ScanTime: "Scan Time",
  },
  //Data Management
  DataManagement: {
    DataManagement: "gestione dei dati",
    AllCompanies: "Tutte le aziende",
    CompaniesViewed: "Aziende visualizzate",
    CompaniesCollected: "Aziende raccolte",
    CompaniesUploaded: "Aziende caricate",
    MyPortfolio: "Il mio portafoglio",
    Date: "Data",
    CompanyName: "Nome dell'azienda",
    Country: "Paese",
    CompanyType: "Tipo di azienda",
    CompanyStatus: "Stato dell'azienda",
    DQI: "DQI",
    Download: "Scaricamento",
    Addcompanies: "Aggiungi aziende",
    Filter: "Filter",
    Selectcountry: "Seleziona il paese",
    Selectindustry: "Seleziona il settore",
    Selectcompanytype: "Seleziona il tipo di azienda",
    Selectcompanysize: "Seleziona la dimensione dell'azienda",
    Selectcompanystatus: "Seleziona lo stato dell'azienda",
    Selectlistedcompanies: "Seleziona le società quotate",
    Selectcompanyyearsinbusiness: "Seleziona gli anni di attività dell'azienda",
    Industry: "Industria",
    CompanySize: "Dimensioni dell'azienda",
    Listed: "Quotate",
    CompanyAge: "Età dell'azienda",
    SelectYear: "Seleziona anno",
    SelectQuarter: "Seleziona trimestre",
    SelectMonth: "Seleziona mese",
    Reset: "Reset",
    Search: "Ricerca",
    MyDatabase: "Il mio database",
    Locations: "Sedi",
    YearsinBusiness: "Anni di attività",
    CompanyDQI: "DQI",
    RiskScan: "Scansione del rischio",
    CreditAssessment: "Valutazione del credito",
    Uptodate: "Aggiornato",
    Average: "Media",
    Insufficient: "Insufficient",
    Good: "Bene",
    Caution: "Attenzione",
    Unknown: "Sconosciuta",
    CompanyTag: "Etichetta aziendale",
    Remove: "Rimuovere",
    Uploaded: "Caricato",
    Identified: "Identificato",
    Notmatched: "Non abbinato",
    UploadCompanies: "Carica aziende",
    Match: "Incontro",
    Delete: "Eliminare",
    OnlineMatching: "Abbinamento online",
    Identifythecompanywithmanualcheck:
      "Identificare l'azienda con controllo manuale",
    Identifyacompanymanually: "Identificare manualmente un'azienda",
    Pleaseprovideanyrelevantinformation:
      "Fornisci tutte le informazioni rilevanti che potrebbero migliorare i risultati della ricerca. Il nostro analista dati ti metterà in contatto con l'azienda più adatta.",
    RegistrationID: "ID aziendale",
    StateProvince: "Stato/Provincia",
    Address: "Indirizzo",
    Otherinformation: "Altre informazioni",
    Submit: "Invia",
    Cancel: "Compito",
    Confirm: "Confermare",
    EnterRegistrationID: "Inserisci l'ID di registrazione",
    EnterAddress: "Inserisci l'indirizzo",
    EnterInformation: "Inserisci le informazioni",
    User: "Utente",
    Task: "Task",
    NoofCompanies: "Numero di aziende",
    Entercompanyname: "Inserisci il nome dell'azienda",
    SaveYourPortfolio: "Salva il tuo portafoglio",
    PortfolioName: "Nome del portafoglio",
    Notes: "Note",
    Edit: "Modifica",
    EnterPortfolioName: "Inserisci il nome del portfolio",
    EnterUserName: "Inserisci l'utente",
    SelectTaskName: "Seleziona l'attività",
    EnterNotes: "Inserisci le note",
    StartingMonth: "Mese di inizio",
    EndMonth: "Fine mese",
  },
  ...itLocale,
};

export default it;
